import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Form } from "react-bootstrap";
import InputMask from 'react-input-mask';
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../commons/inFormTypes";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loaders from '../components/Loaders'


function Reports() {
  const [snip, setSnip] = useState(false);
  const [trashList, setTrashList] = useState([]);
  const [trash, setTrash] = useState(0);
  const [Stchange, setstchange] = useState(false);
  const [seenFile, setSeenFile] = useState([]);
  const [dateStart, setDateStart] = useState();
  const [dateEnd, setDateEnd] = useState();
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate();


  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "GetList_Trash")
        .then((res) => {
          console.log(res.data.data)
          if (res.data.result === "true") {
            setTrashList(res.data.data);
          } else {
          }
        });
    }
  }, []);

  const searchHandler = () => {
    const axios = require("axios");
    setSnip(true)
    axios
      .post(apiUrl + "Get_StationReports", {
        // code: orderTypeId,
        TokenId: userToken,
        // Code_Meli: "",
        // DateStart: dateStart,
        // DateEnd: dateEnd,
        DateFrom: dateStart,
        DateTo: dateEnd,
        Type_Trash: trash
      })
      .then((res) => {
        setSnip(false)
        if (res.data.result === "true") {
          setSeenFile(res.data.data);
        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    // if (Stchange)
    //   setstchange(false)
    // else
    //   setstchange(true)
  }

  const selectTrashHandler = (e) => {
    setTrash(e.target.value);
  }

  return (
    <div>
      <Container>

        <Row className="justify-content-center">
          <Col xs={11}>
            <Row className="justify-content-center gy-3">

              <Col xs={12} className="rgc-search">
                <Row className="justify-content-center align-items-center">

                  <Col xs={12} md={3} className="text-center">
                    <Form.Label>نوع پسماند</Form.Label>
                    <Form.Select
                      className="rgc-select"
                      value={trash}
                      onChange={(e) => selectTrashHandler(e)}
                    >
                      <option key={0} value="0">
                        لطفا انتخاب کنید
                      </option>
                      {trashList.map((data, index) => (
                        <option key={index} value={data.Trashd}>
                          {data.Tittle}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  <Col xs={6} md={3} className="text-center">
                    <Form.Group controlId="formBasicDate1">
                      <Form.Label>از تاریخ:</Form.Label>
                      <InputMask
                        mask="9999/99/99"
                        className="rgc-input-date"
                        id="formBasicDate1"
                        value={dateStart}
                        onChange={(e) => setDateStart(e.target.value)}
                      >
                      </InputMask>
                    </Form.Group>
                  </Col>

                  <Col xs={6} md={3} className="text-center">
                    <Form.Group controlId="formBasicDate2">
                      <Form.Label> تا تاریخ:</Form.Label>
                      <InputMask
                        mask="9999/99/99"
                        className="rgc-input-date"
                        id="formBasicDate2"
                        value={dateEnd}
                        onChange={(e) => setDateEnd(e.target.value)}
                      >
                      </InputMask>
                    </Form.Group>
                  </Col>

                  <Col xs={12} className="text-center mt-4">
                    <Button className="rgc-orderreg-btn rgc-order-btn-sub" onClick={searchHandler}>
                      <Loaders loads={snip} />
                      جستجو
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} className="rgc-orderreg-items">
                <Row className="justify-content-center">
                  <Col xs={6} className="text-start">
                    <span>جمع کل وزن پسماند تحویلی:</span>
                  </Col>
                  <Col xs={6} className="text-end rgc-orderreg-txt">
                    <span>{seenFile.reduce((acc, item) => acc + 1 * item.Sub_Weight, 0)}</span>
                  </Col>
                </Row>
              </Col>
              {
                seenFile.length === 0 ?
                  <Col xs={12} className="rgc-orderreg-items rgc-score-body text-center" >
                    <span>سفارش موجود نیست</span>
                  </Col>
                  :
                  seenFile.map((data, index) => {
                    return (
                      <Col xs={12} lg={5} className="rgc-orderreg-items" key={index}>
                        <Row className="justify-content-center">

                          <Col xs={3} className="">
                            <span>نوع پسماند:</span>
                          </Col>
                          <Col xs={9} className="text-end rgc-orderreg-txt">
                            <span>{data.Type_Trash_Tittle}</span>
                          </Col>

                          <Col xs={3} className="">
                            <span> وزن:</span>
                          </Col>
                          <Col xs={9} className="text-end rgc-orderreg-txt">
                            <span>{data.Sub_Weight}{data.Type_Weight_Title}</span>
                          </Col>

                        </Row>
                      </Col>
                    )
                  })
              }

            </Row>
          </Col>
        </Row>
      </Container>
    </div >
  )
}

export default Reports